export default [
    {
        path: 'model_assessment/reservoirs',
        name: 'list-reservoirs',
        component: () => import('pages/model_assessment/reservoirs/list'),
    },
    {
        path: 'model_assessment/reservoir/:reservoirId/review/:classifierType/:classifierId/:attribute',
        name: 'review-reservoir',
        component: () => import('pages/model_assessment/reservoirs/review'),
    },
    {
        path: 'model_assessment/review/:reviewId/evaluation/:evaluationId',
        name: 'review-evaluation-detail',
        component: () => import('pages/model_assessment/reservoirs/review/view_evaluation'),
    },
    {
        path: 'model_assessment/review/:reviewId/evaluation',
        name: 'review-evaluation-history',
        component: () => import('pages/model_assessment/reservoirs/review/evaluation_history'),
    },
];
